import { baseURL } from "@/constants/v2/endPoints";
import * as apiService from "./apiService";

const IMPORTS_URL = `${baseURL}api/v2/imports`;

const unwrap = (response) => {
  if (response?.errorCode !== 0) {
    throw new Error(response?.message || "Request failed");
  }
  return response.result;
};

const call = async (...args) => {
  let response;
  try {
    response = await apiService.apiCall(...args);
  } catch (err) {
    if (err?.response?.status === 401) {
      throw new Error("Your session has expired. Please sign in again.");
    }
    throw new Error(
      err?.response?.data?.message || "Something went wrong. Please try again.",
    );
  }
  return unwrap(response);
};

export async function previewCsvRows(rows) {
  return call(`${IMPORTS_URL}/csv/preview`, "POST", { rows });
}

export async function getReadyToReview() {
  return call(`${IMPORTS_URL}/review`, "GET");
}

export async function publishImportedDraft(wantAdId, buyersAgreementSigned) {
  return call(`${IMPORTS_URL}/review/${wantAdId}/publish`, "POST", {
    buyersAgreementSigned: buyersAgreementSigned === true,
  });
}

export async function discardImportedDraft(wantAdId) {
  return call(`${IMPORTS_URL}/review/${wantAdId}/discard`, "POST", {});
}

export async function stageImport({ source, rows, fileName }) {
  return call(`${IMPORTS_URL}/batches`, "POST", { source, rows, fileName });
}

export async function addImportRows(batchId, rows) {
  return call(`${IMPORTS_URL}/batches/${batchId}/rows`, "POST", { rows });
}

export async function getImport(batchId) {
  return call(`${IMPORTS_URL}/batches/${batchId}`, "GET");
}

export async function listRecentImports() {
  return call(`${IMPORTS_URL}/batches`, "GET");
}

export async function updateImportRow(batchId, rowId, patch) {
  return call(`${IMPORTS_URL}/batches/${batchId}/rows/${rowId}`, "PATCH", patch);
}

export async function selectImportRows(batchId, rowIds, selected) {
  return call(`${IMPORTS_URL}/batches/${batchId}/rows`, "PATCH", { rowIds, selected });
}

export async function removeImportRow(batchId, rowId) {
  return call(`${IMPORTS_URL}/batches/${batchId}/rows/${rowId}`, "DELETE");
}

export async function commitImport(batchId) {
  return call(`${IMPORTS_URL}/batches/${batchId}/commit`, "POST", {});
}

export async function cancelImport(batchId) {
  return call(`${IMPORTS_URL}/batches/${batchId}/cancel`, "POST", {});
}

export async function undoImport(batchId) {
  return call(`${IMPORTS_URL}/batches/${batchId}/undo`, "POST", {});
}
